import React, { Component } from 'react'
import { GET_LIST } from 'react-admin'
import _ from 'lodash'

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import HistoryIcon from '@material-ui/icons/History';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core/styles';

import HistoryEntry from './HistoryEntry'
import dataProvider from '../../../utils/dataProvider'


const styles = {
    title : {
      display: 'inline-flex',
      verticalAlign: 'middle',
      alignItems: 'center',
      fontSize: 23,
      '& svg' : { color: '#019EAC', paddingRight : 10 }
    },
    collapsedContent: {
      padding: '30px',
      backgroundColor: '#f7f7f7'
    }
}

class History extends Component {
    state = {
      open: false,
      loading: false,
      entries: []
    }

    handleOnClick = () => {
      const { resource, record } = this.props
      this.setState({ open: true })
      this.fetchPreviousVersions(resource, record)
    }

    handleClose = () => {
      this.setState({ open: false, loading: false })
    }

    fetchPreviousVersions = (resource, record) => {
      this.setState({ loading: true });

      const params = {
        pagination: {
          page: 1,
          perPage: 10000
        },
        sort: { field: 'date', order: 'DESC' },
        filter: {}
      }
      dataProvider(GET_LIST, `${resource}/${record.id}/versions`, params)
        .then(response => {
          this.setState({ loading: false, entries: response.data })
        })
    }

    renderEntries() {
        return _.map(this.state.entries, e => {
          return <HistoryEntry key={e.id} entry={e} {...this.props}/>
        })
    }

    render() {
        const { open, loading, entries } = this.state
        const { classes, permissions } = this.props

        const { basePath, ...rest } = this.props
        return (
          <div {...rest}>
            <IconButton color="primary" onClick={this.handleOnClick}>
              <HistoryIcon />
            </IconButton>
            <Dialog
              open={open}
              onClose={this.handleClose}
              fullWidth={true}
              maxWidth={'md'}
            >
              <DialogTitle>
                <Typography className={classes.title}>
                  <HistoryIcon /> Historial de Cambios
                </Typography>
              </DialogTitle>
              <DialogContent>
                {loading
                  ? <CircularProgress color="primary"/>
                  : (
                    <Table className={classes.table}>
                      <TableHead>
                        <TableRow>
                          <TableCell>ID</TableCell>
                          <TableCell>Fecha Modificación</TableCell>
                          {!["coordinado", "guest"].includes(permissions.role)
                            && <TableCell>Autor</TableCell>}
                          <TableCell>Detalle</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {!!entries.length
                          ? this.renderEntries()
                          : (
                            <TableRow>
                              <TableCell align="right" colSpan={4}>
                                No se encontraron registros
                              </TableCell>
                            </TableRow>
                          )
                        }
                      </TableBody>
                    </Table>
                  )
                }
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="secondary">
                  Cerrar
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        )
    }
}

export default withStyles(styles)(History)
